module.exports = "div.w3-container {\r\n    max-width: 400px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/expenses/expense-form/expense-form.component.css
// module id = ./src/app/components/expenses/expense-form/expense-form.component.css
// module chunks = main